import PaginatedListState from 'flarum/common/states/PaginatedListState';
import app from 'flarum/forum/app';

export default class HomeActivityLeaderboardState extends PaginatedListState {
	get type() {
		return 'of/active_users';
	}

	loadPage(page = 1) {
		const preloadedUsers = app.preloadedHomeApiDocument('leaderboard');

		if (preloadedUsers) {
			this.initialLoading = false;

			return Promise.resolve(preloadedUsers);
		}

		return super.loadPage(page);
	}
}
